import * as yup from "yup"

export const validationSchema = yup.object().shape({
    payment_term_code: yup.string().label("Payment term code").required().max(2, 'Maximum code is 2 characters'),
    payment_term_name: yup.number().label("Payment term name").required().max(100, "Must be 100 characters or less").test('is-valid-rate', 'Rate must be between -999.9999 and 999.9999', val => val !== undefined && val >= -999.9999 && val <= 999.9999),
    description: yup.string().label("Description").optional()
  })